const getFaasApiUrl = (state) => state.getIn(['config', 'faasApiUrl']);

export default getFaasApiUrl;
